import { NormalizedCargo } from "../../../domain/models/cargo-model";
import { PrintCargoLabel } from "../../../domain/usecases/print-label/print-cargo-label";
import { ZebraPrinter } from "../../protocols/zebra-printer/zebra-printer";

export class ZebraPrintCargoLabel implements PrintCargoLabel {
  constructor(private readonly zebraPrinter: ZebraPrinter) {}
  async print(cargo: NormalizedCargo): Promise<void> {
    const address = [
      cargo.street,
      cargo.propertyNumber,
      cargo.neighborhood,
      cargo.city,
      cargo.referencePoint,
      "-",
      cargo.additionalInformation,
    ].join(" ");
    const addressArray = [];

    for (let i = 0; i < address.length; i += 23) {
      const chunk = address.substring(i, i + 23);
      addressArray.push(chunk);
    }
    const zplCode = `
    ^XA
  
    ^FX Top section with logo, name and address.
    ^CF0,60
    ^FO140,50^FDElimacol Acabamentos^FS
    ^CF0,30
    ^FO50,170^GB700,3,3^FS
    
    ^FX Second section with recipient address and permit information.
    ^CFA,30
    ^FO50,200^FDCliente^FS
    ^CF0,40
    ^FO50,250^FD${
      cargo.clientName.length <= 54
        ? cargo.clientName
        : cargo.clientName.substring(0, 54)
    }^FS
    ^CFA,30
    ^FO50,310^FDPedido^FS
    ^CF0,40
    ^FO50,360^FD${cargo.orderReference}^FS
    ^CFA,30
    ^FO50,410^FDCarga^FS
    ^CF0,40
    ^FO50,460^FD${cargo.reference}^FS
    
    ^CFA,15
    
    ^FO50,520^GB700,3,3^FS
    
    ^FX Fourth section (the two boxes on the bottom).
    ^FO50,550^GB700,400,3^FS
    ^CF0,50
    ${addressArray.map((string, index) => {
      if (index > 4) return;
      return "^FO100," + (610 + index * 70) + "^FD" + string + "^FS";
    })}
    
    ^CFA,30
    ${
      false &&
      `^FO50,990^FDConferido por^FS
    ^FO300,990^FDWagner^FS
    ^FO50,1040^FDEm^FS
    ^FO300,1040^FD12/08/2024^FS`
    }
    
    ^XZ
    `;

    return this.zebraPrinter.print(zplCode);
  }
}
